exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.chat-new .input-wrap{display:flex;margin:.7em .5em .7em .5em\n}\n.chat-new .input-wrap input{width:100%\n}\n.chat-new .search-icon{margin-right:.3em\n}\n.chat-new .member-list{padding-bottom:.7rem\n}\n.chat-new .basic-user-card:hover{cursor:pointer;background-color:var(--selectedPost, rgb(21, 30, 42))\n}\n.chat-new .go-back-button{cursor:pointer;width:28px;text-align:center;padding:.6em;margin:-0.6em .6em -0.6em -0.6em\n}", ""]);

// exports
